/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

// @ts-nocheck

'use strict'
// https://stackoverflow.com/questions/15312529/resolve-circular-references-from-json-object
export function resolveReferences(json, removeIds?) {
    if (typeof json === 'string') json = JSON.parse(json)

    var byid = {}, // all objects by id
        refs = [] // references to objects that could not be resolved
    json = (function recurse(obj, prop, parent) {
        if (typeof obj !== 'object' || !obj)
            // a primitive value
            return obj
        if (Object.prototype.toString.call(obj) === '[object Array]') {
            for (var i = 0; i < obj.length; i++)
                // check also if the array element is not a primitive value
                if (typeof obj[i] !== 'object' || !obj[i])
                    // a primitive value
                    continue
                else if ('$ref' in obj[i]) obj[i] = recurse(obj[i], i, obj)
                else obj[i] = recurse(obj[i], prop, obj)
            return obj
        }
        if ('$ref' in obj) {
            // a reference
            var ref = obj.$ref
            if (ref in byid) return byid[ref]
            // else we have to make it lazy:
            refs.push([parent, prop, ref])
            return
        } else if ('$id' in obj) {
            var id = obj.$id
            if (removeIds) {
                delete obj.$id // this strips the "$id' field from the JSON.
            }
            byid[id] = obj
        }

        if ('$values' in obj)
            // an array
            obj = obj.$values.map(recurse)
        // a plain object
        else for (var prop1 in obj) obj[prop1] = recurse(obj[prop1], prop1, obj)

        return obj
    })(json) // run it!

    for (var i = 0; i < refs.length; i++) {
        // resolve previously unknown references
        var ref = refs[i]
        ref[0][ref[1]] = byid[ref[2]]
        // Notice that this throws if you put in a reference at top-level
    }
    return json
}
